import React from "react";
export default function RegisterSection() {
  return (
    <section id="register" className="parallax-section">
      <div className="container">
        <div className="row">
          <div className="wow fadeInUp col-md-7 col-sm-7" data-wow-delay="0.6s">
            <h2>Online Entry</h2>
          </div>
          <div className="wow fadeInUp col-md-5 col-sm-5" data-wow-delay="1s">
            <form action="#" method="post">
              <input name="firstname" type="text" className="form-control" id="firstname" placeholder="Login ID" />
              <input name="password" type="password" className="form-control" id="password" placeholder="Password" />
              <input name="submit" type="submit" className="form-control" id="submit" value="login" />
            </form>
          </div>
          <div className="col-md-1"></div>
        </div>
      </div>
    </section>
  );
}
